import MultiSelect from './multi-select'

export default MultiSelect
